export const getFrontEndOrigin = (forceReturnOrigin = false) => {
  if (window.location.hostname === 'localhost' && !forceReturnOrigin) {
    return 'https://stage-www.svensktnaringsliv.net';
  }
  return window.location.origin;
};
